import React from 'react';
import { isArray } from 'lodash';
import { useTranslation } from 'react-i18next';

import {
  Typography,
  PLATFORM_THEME_COLORS,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';

import { getCorrectFormatEmployeeInfoField } from 'src/components/employee/employee-details.helpers';

import { generateReactKey } from 'src/common/helpers/common.helpers';

import {
  IEducationAndSkills,
} from '../../../../../auth/sub-pages/questionnaire/questionnaire.interfaces';

import {
  ElementContainer,
  InfoBlock,
  InfoBlockContainer,
  InfoElement,
  InfoWrapper,
  InfoWrapperTitle,
} from '../../open-questionnaires-details.styles';


const EducationsAndSkillsQuestionnairesDetails = ({
  educationAndSkills,
}: {
  educationAndSkills: IEducationAndSkills;
}) => {
  const { t } = useTranslation('employee');

  const {
    schoolName,
    universityName,
    furtherName,
    driversLicenses,
    trainingName,
    skills,
  } = educationAndSkills;

  const firstColumn = {
    schoolName,
    universityName,
  };

  const secondColumn = {
    furtherName,
    trainingName,
  };

  const thirdColumn = {
    driversLicenses,
    skills,
  };

  const data = [firstColumn, secondColumn, thirdColumn];

  return (
    <InfoWrapper>
      <InfoWrapperTitle>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('employee:labels.educationAndSkills')}
        </Typography>
      </InfoWrapperTitle>

      <InfoBlock>
        {data.map((el) => {
          return (
            <InfoBlockContainer key={generateReactKey()}>
              {Object.entries(el).map(([key, value]) => {
                const isSkills = key === 'skills';

                return isSkills ? (
                  <InfoElement key={generateReactKey()}>
                    <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
                      {t('employee:educationsAndSkills.labels.skills')}
                    </Typography>
                    {isArray(value) && value?.map((item, ind) => (
                      <ElementContainer key={`${ind}-${item?.name}-scills-container`}>
                        <InfoElement>
                          <Typography weight="bold">{`${t(
                            'employee:labels.skillsName'
                          )}:`}</Typography>
                          <Typography fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
                            {item?.name || '-'}
                          </Typography>
                        </InfoElement>
                        <InfoElement>
                          <Typography weight="bold">{`${t(
                            'common:labels.description'
                          )}:`}</Typography>
                          <Typography fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
                            {item?.description || '-'}
                          </Typography>
                        </InfoElement>
                      </ElementContainer>
                    ))}
                  </InfoElement>
                ) : (
                  <InfoElement key={generateReactKey()}>
                    <Typography weight="bold">{`${t(
                      `employee:questionnaire.educationAndSkills.labels.${key}`
                    )}`}</Typography>
                    <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                      {getCorrectFormatEmployeeInfoField({ t, key, value }) || '-'}
                    </Typography>
                  </InfoElement>
                );
              })}
            </InfoBlockContainer>
          );
        })}
      </InfoBlock>
    </InfoWrapper>
  );
};

export default EducationsAndSkillsQuestionnairesDetails;
